import React from 'react';
import { ArrowUpRight, ArrowDown } from 'lucide-react';

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden">
      <div className="absolute inset-0 bg-grid-soft opacity-70 pointer-events-none" />
      <div className="absolute -top-20 -right-20 w-[420px] h-[420px] rounded-full pointer-events-none"
           style={{ background: 'radial-gradient(circle, rgba(255,92,77,0.18) 0%, rgba(255,92,77,0) 65%)' }} />

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="eyebrow mono-font text-black/70 fade-up">Tech Staffing · Software Studio</div>

        <h1 className="display-font mt-8 text-[16vw] md:text-[10.5vw] leading-[0.92] fade-up" style={{ animationDelay: '0.05s' }}>
          <span className="block text-black">Elite</span>
          <span className="block accent-red">Engineers,</span>
          <span className="block text-black">On Demand.</span>
        </h1>

        <p className="mt-10 max-w-xl text-base md:text-lg text-black/60 fade-up" style={{ animationDelay: '0.15s' }}>
          Anitix places senior engineering talent inside your team in days — and builds the products that scale them. Staffing and software, under one roof.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-4 fade-up" style={{ animationDelay: '0.2s' }}>
          <a href="#contact" className="btn-primary inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-semibold">
            Build Your Team <ArrowUpRight className="w-4 h-4" />
          </a>
          <a href="#work" className="btn-secondary inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-semibold">
            See Our Work
          </a>
        </div>

        <div className="mt-14 flex items-center gap-3 text-black/50 mono-font">
          <ArrowDown className="w-4 h-4 scroll-arrow" />
          <span>Scroll</span>
        </div>
      </div>
    </section>
  );
}
